<app-scroll-view
  class="scroll-view"
  [scrollable]="!!scrollable"
  [vertical]="!!vertical"
  [horizontal]="!!horizontal"
  [@listAnimation]
  [@.disabled]="!animate"
>
  <ng-container *ngIf="!isEmptyList(); else emptyListTpl">
    <ng-template
      [ngTemplateOutlet]="containerTplRef?.templateRef ?? itemListTpl"
      [ngTemplateOutletContext]="{
        itemListTemplate: itemListTpl
      }"
    ></ng-template>
  </ng-container>
</app-scroll-view>

<ng-template #emptyListTpl>
  <div class="empty-message-wrapper" [@emptyMessage]="'true'" emptyMessage>
    <ng-template
      [ngTemplateOutlet]="emptyListTplRef?.templateRef ?? defaultEmptyListTpl"
    ></ng-template>
  </div>
</ng-template>

<ng-template #defaultEmptyListTpl>
  <div class="empty-message">
    {{ emptyMessage }}
  </div>
</ng-template>

<ng-template #itemListTpl>
  <ng-template
    *ngFor="let item of items; let i = index; trackBy: trackByInternal"
    [ngTemplateOutlet]="itemTplRef?.templateRef"
    [ngTemplateOutletContext]="{
      item,
      index: i,
      key: trackByInternal(i, item)
    }"
  ></ng-template>
</ng-template>
